import MissedDepartureMutation from './MissedDepartureMutation';

export default MissedDepartureMutation;
